function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  "data-name": "layer1",
  d: "M20.8 36H14a4 4 0 0 1-4-4V22a4 4 0 0 1 4-4h6.8m22.4 18H50a4 4 0 0 0 4-4V22a4 4 0 0 0-4-4h-6.8",
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  strokeLinejoin: "round",
  strokeLinecap: "butt"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  "data-name": "layer2",
  d: "M39.9 39.4A15.3 15.3 0 0 0 46 27c0-8.3-6.3-15-14-15s-14 6.7-14 15a15.3 15.3 0 0 0 6.1 12.4A24.1 24.1 0 0 0 8 62h48a24.1 24.1 0 0 0-16.1-22.6z",
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  strokeLinejoin: "round",
  strokeLinecap: "butt"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  "data-name": "layer1",
  d: "M16 18A16 16 0 0 1 32 2a16 16 0 0 1 16 16",
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  strokeLinejoin: "round",
  strokeLinecap: "butt"
});

var SvgOrionHeadphonesUser = function SvgOrionHeadphonesUser(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOrionHeadphonesUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Orion_headphones-user.f9ae3dbf.svg";
export { ForwardRef as ReactComponent };